import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import styles from '../../pages/AgentSearch.scss';

SurroundOptions.propTypes = {
  localAgencies: PropTypes.bool.isRequired,
  surroundingSuburbs: PropTypes.bool.isRequired,
  returnFunc: PropTypes.func.isRequired,
};

function SurroundOptions(props) {
  const {localAgencies, surroundingSuburbs} = props;
  return (
    <div className="d-flex flex-column flex-md-row justify-content-center w-100 mt-2">
      <div className="mr-md-4"><FormControlLabel className={styles.agencyOptionLabel} control={<Checkbox checked={localAgencies} onChange={() => props.returnFunc([{localAgencies: !localAgencies}, {page: 1}])} name="showLocal" size="small" />} label="Only show agencies located in this area" /></div>
      {/*<div className="ml--md-4"><FormControlLabel className={styles.agencyOptionLabel} control={<Checkbox checked={surroundingSuburbs} onChange={() => props.returnFunc([{surroundingSuburbs: !surroundingSuburbs}])} name="showSurrounding" size="small" />} label="Surrounding suburbs" /></div>*/}
    </div>
  );
}

export default SurroundOptions;
